// extracted by mini-css-extract-plugin
export default {"loading":"styles_loading__ZDlpr","lds-ellipsis1":"styles_lds-ellipsis1__Fno3E","lds-ellipsis2":"styles_lds-ellipsis2__gCisI","lds-ellipsis3":"styles_lds-ellipsis3__rXMjx"};